/* eslint-disable */
import {parseVideo, Video, VideoChangeSet,AddVideoInfo, EditVideoInfo, UploadDocumentIF, UpdateVideoSlideIF} from "./models/Video";
import axios from "../cotAxios";
import {parseVideoReaction, VideoReaction, VideoReactionChangeSet} from "./models/VideoReaction";
import {parseVideoComment, VideoComment, VideoCommentChangeSet} from "./models/VideoComment";
import {parseVideoExtraMaterial, VideoExtraMaterial} from "./models/VideoExtraMaterial";
import {parseSearchResult, SearchResult} from "../../viewer/search/SearchResult";
import {SearchQuery} from "../../viewer/search/SearchQuery";
import {FilterResult, Tag, VideoFilter} from "./models/VideoFilter";
// import qs from "qs";
import {parseTag} from "./models/VideoTag";

export default {
    getAll(): Promise<Array<Video>> {
        return axios.get("/api/video")
            .then(({data}) => data.map(parseVideo))
            .catch((error) => {return error;});
   },
    get(id: number | string, userId: string): Promise<Video | undefined> {
        return axios.get("/api/getVideoById",{params: {videoId: id, userId: userId},withCredentials: true})
            .then(({data}) => parseVideo(data))
            .catch((error) => {return error;});
   },
    create(videoData: FormData): Promise<Video> {
        return axios.post("/api/video/upload", videoData)
            .catch((error) => {return error;});
   },
    update(id: number, changeSet: VideoChangeSet): Promise<Video> {
        return axios.put(`/api/video/${id}`, changeSet)
            .then(({data}) => parseVideo(data))
            .catch((error) => {return error;});
   },
    uploadExtraMaterial(id: number, fileData: FormData): Promise<VideoExtraMaterial> {
        return axios.post(`/api/video/${id}/material/upload`, fileData)
            .then(({data}) => parseVideoExtraMaterial(data.list[0]))
            .catch((error) => {return error;});
   },
    deleteExtraMaterial(materialId: number): Promise<void> {
        return axios.delete(`/api/video/material/${materialId}`)
            .catch((error) => {return error;});
   },
    delete(id: number): Promise<void> {
        return axios.delete(`/api/video/${id}`)
            .catch((error) => {return error;});
   },
    addViewingHistory(userId: string ,id: number, ms: number): Promise<Video> {
        return axios.post("/api/addViewingHistory",{userId: userId,videoId: id, progressMillis: ms})
            .catch((error) => {return error;});
   },
    incrementViews(userId: string ,id: number): Promise<any> {
        return axios.post("/api/incrementViewCount",{userId: userId,videoId: id})
            .catch((error) => {return error;});
   },
    createReaction(changeSet: VideoReactionChangeSet): Promise<VideoReaction> {
        return axios.post("/api/addReaction", changeSet)
            .then(({data}) => parseVideoReaction(data))
            .catch((error) => {return error;});
   },
    createComment(changeSet: VideoCommentChangeSet): Promise<VideoComment> {
        return axios.post("/api/addComment", changeSet)
            .then(({data}) => parseVideoComment(data))
            .catch((error) => {return error;});
   },
    search(searchQuery: SearchQuery): Promise<SearchResult> {
        return axios.post("/api/search", searchQuery)
            .then(({data}) => parseSearchResult(data))
            .catch((error) => {return error;});
   },
    getByFilter(userId: string, filter: VideoFilter): Promise<FilterResult> {
        return axios.post("/api/getVideoListByConditions", {
            userId: userId,
            professionals: filter.professional,
            programs: filter.program,
            projects: filter.project,
            tags: filter.tag,
            slideFlg: filter.slideFlg
       })
            .then(({data}) => {
                const result: FilterResult = {
                    videos: data.videos.map(parseVideo),
                    tags: data.tags
               };
                return result;
           })
            .catch((error) => {return error;});
   },
    getTagList(tags: string[]): Promise<Tag[] | undefined> {
        return axios.get("/api/getTagList", {params: {tags: String(tags)}})
            .then(({data}) => data.map(parseTag))
            .catch((error) => {return error;});
   },

   delCommentToVideo(videoId: number,commonId: number | string): Promise<Tag[] | undefined> {
    return axios.get("/api/delCommentToVideo",{params: {videoId: videoId, commonId: commonId},withCredentials: true})
        .then(({}) => true)
        .catch((error) => {return error;});
    },

    //ビデオ追加
    AddVideo(video: AddVideoInfo): Promise<any> {
        const params = new FormData();

        params.append("file", video.file !== undefined && video.file !== null ? video.file : new File([""], "empty"));
        params.append("imageFile", video.imageFile !== undefined && video.imageFile !== null  ? video.imageFile : new File([""], "empty") );
        params.append("video", new Blob([JSON.stringify(video.video)], {
            type: "application/json"
       }));
        // documentFile
        if(video.documentFile.length > 0){
            video.documentFile.map((row) =>
                params.append("documentFile", row)
            );
       }else{
            params.append("documentFile",new File([""], "empty"));
       }

        // documentName
        if(video.documentName.length > 0){
            let sendDocumetName = "";
            video.documentName.map((row) => {
                if(sendDocumetName !== ""){
                    sendDocumetName = sendDocumetName + "," + row;
               }else{
                    sendDocumetName= row;
               }
                return null;
           });

            params.append("documentName", new Blob([sendDocumetName], {
                type: "application/json"
           }));
       }else{
            params.append("documentName",new Blob([JSON.stringify("")], {
                type: "application/json"
           }));
       }
        return axios.post("/api/upload",params,
            {
                headers: {
                    "content-type": "multipart/form-data"
               }
           })
            .then(
                ({data}) => data
            )
            .catch((error) => {return error;});
   },

    // ビデオ編集
    EditVideo(video: EditVideoInfo): Promise<any> {
        console.log("video",video);

        const params = new FormData();
        params.append("file", video.file !== undefined && video.file !== null ? video.file : new File([""], "empty"));
        params.append("imageFile", video.imageFile !== undefined && video.imageFile !== null  ? video.imageFile : new File([""], "empty") );
        params.append("video",new Blob([JSON.stringify(video.video)], {
            type: "application/json"
       }));
        return axios.post("/api/editVideo",params,
            {
                headers: {
                    "content-type": "multipart/form-data"
               }
           })
            .then(
                ({data}) => data
            )
            .catch((error) => {return error;});

   },

    // ビデオ資料アップロード
    UploadDocument(document: UploadDocumentIF): Promise<any> {
        console.log("UploadDocument");
        console.log("document", document);
        const params = new FormData();

        // userId
        params.append("userId", String(document.userId));

        // videoId
        params.append("videoId", String(document.videoId));

        // materialId
        if(document.materialId.length > 0){

            let sendMaterialId = "";
            document.materialId.map((row) => {
                if(sendMaterialId !== ""){
                    sendMaterialId = sendMaterialId + "," + String(row);
               }else{
                    sendMaterialId= String(row);
               }
                return null;
           });
            params.append("materialId", new Blob([sendMaterialId], {
                type: "application/json"
           }));

       }else{
            params.append("materialId",new Blob([JSON.stringify("")], {
                type: "application/json"
           }));
       }

        // documentFile
        if(document.documentFile !== undefined && document.documentFile !== null && document.documentFile.length > 0){
            document.documentFile.map((row) =>
                params.append("documentFile", row)
            );
       }else{
            params.append("documentFile",new File([""], "empty"));
       }

        // documentName
        if(document.documentName.length > 0){
            let sendDocumetName = "";
            document.documentName.map((row) => {
                if(sendDocumetName !== ""){
                    sendDocumetName = sendDocumetName + "," + row;
               }else{
                    sendDocumetName= row;
               }
                return null;
           });

            params.append("documentName", new Blob([sendDocumetName], {
                type: "application/json"
           }));
       }else{
            params.append("documentName",new Blob([JSON.stringify("")], {
                type: "application/json"
           }));
       }


        // 送信
        return axios.post("/api/uploadMaterial",params,
            {
                headers: {
                    "content-type": "multipart/form-data"
               }
           })
            .then(
                ({data}) => data
            )
            .catch((error) => {return error;});
   },

    //ビデオ削除
    DeleteVideo(videoId: number): Promise<void> {
        return axios.get(`/api/deleteVideo?videoId=${videoId}`)
            .then(
                ({data}) => data
            )
            .catch((error) => {return error;});
   },

    // ビデオスライド資料取得
    GetVideoSlide(videoId: string, fileId: string): Promise<void>{
        return axios.get("/api/getVideoSlide",{params: {videoId: videoId, fileId: fileId}})
            .then(
                ({data}) => data
            )
            .catch((error) => {return error;});
   },

    // ビデオスライド資料追加・編集
    UpdateVideoSlide(updateVideoSlide: UpdateVideoSlideIF): Promise<void>{
        const params = new FormData();
        params.append("videoId", String(updateVideoSlide.videoId));
        params.append("file", updateVideoSlide.file !== undefined && updateVideoSlide.file !== null  ? updateVideoSlide.file : new File([""], "empty") );
        params.append("slideName", updateVideoSlide.slideName === "" ? "empty" : updateVideoSlide.slideName);
        params.append("isPublic", String(updateVideoSlide.isPublic));
        params.append("videoSlides",new Blob([JSON.stringify(updateVideoSlide.videoSlides)], {
            type: "application/json"
       }));
        return axios.post("/api/updateVideoSlide",params,
            {
                headers: {
                    "content-type": "multipart/form-data"
               }
           })
            .then(
                ({data}) => data
            )
            .catch((error) => {return error;});

   },

    // ビデオスライド資料削除
    DeleteVideoSlide(videoId: number): Promise<void> {
        return axios.get(`/api/deleteVideoSlide?videoId=${videoId}`)
            .then(
                ({data}) => data
            )
            .catch((error) => {return error;});
   },

   /**
    * ビデオの字幕情報取得
    *
    * @param videoId ビデオID
    * @param language 言語
    * @returns ビデオの字幕情報
    */
    GetCurrentSubtitle(videoId: number, language: string): Promise<void> {
        return axios.get("/api/getVideoCaptionsById",{params: {videoId: videoId, srcLang: language}})
            .then(
                ({data}) => data
            )
            .catch((error) => {return error;});
   },
};
